function updateSubscriptionChildren() {
  const subscribeRadio = document.querySelector('[data-radio-type="selling_plan_group"]');
  const children = document.querySelector('.shopify_subscriptions_app_block_label_children');

  if (!subscribeRadio || !children) return;

  children.style.display = subscribeRadio.checked ? 'block' : 'none';
}

function addMainSubscriptionPrices() {
  const wrapper = document.querySelector('.shopify_subscriptions_app_block_purchase_options');
  if (!wrapper) return;

  wrapper.querySelectorAll('.shopify_subscriptions_app_block_label > label').forEach(function (label) {
    const radio = label.querySelector('input[type="radio"]');
    if (!radio || label.querySelector('.custom-subscription-price')) return;

    let price = '';

    if (radio.dataset.radioType === 'one_time_purchase') {
      const script = wrapper.querySelector('script[id*="one_time_purchase"]');
      if (script) price = JSON.parse(script.textContent).price.replace(' CAD', '');
    }

    if (radio.dataset.radioType === 'selling_plan_group') {
      const script = wrapper.querySelector(
        'script[id*="subscriptions_money_with_currency_"]:not([id*="one_time_purchase"])'
      );
      if (script) price = JSON.parse(script.textContent).price.replace(' CAD', '');
    }

    if (price) {
      const priceSpan = document.createElement('span');
      priceSpan.className = 'custom-subscription-price';
      priceSpan.textContent = price;
      label.appendChild(priceSpan);
    }
  });
}

document.addEventListener('change', function () {
  updateSubscriptionChildren();
});

document.addEventListener('DOMContentLoaded', function () {
  updateSubscriptionChildren();
  addMainSubscriptionPrices();
});